/* Hero prints product page, version B (research led, BUILD-FW4): step 1 (size and frame), step 2 (make it theirs), one Add to basket button,
   the photo upload, the send-it-later confirm sheet and the Complete the set tiles.
   Basket side (the drawer after the add, inheritance, the drawer bar) is fwh-cart.js. Data: window.FWH (snippets/fwh-data.liquid).
   Built from theme-src/hero/ by scripts/hero/build-theme.ts. */
(function () {
  "use strict";
  // errors on this page reach PostHog error tracking, as on the designer (3 Nov, for the launch health check); the stub queues the call
  try { if (window.posthog && window.posthog.set_config) window.posthog.set_config({ capture_exceptions: true }); } catch (e) {}
  var D = window.FWH, root = document.getElementById("fwh");
  if (!D || !root) return;
  var C = function () { return window.FWHCart; };
  var $ = function (id) { return document.getElementById(id); };
  var design = null;
  D.designs.forEach(function (d) { if (d.code === root.getAttribute("data-design")) design = d; });
  if (!design) design = D.designs[0];
  var has = function (f) { return design.fields.indexOf(f) >= 0; };
  var NAME_RE = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ž' \-]*$/;

  var state = { code: design.code, who: "", size: "A3", frame: "BLACK", child: "", hero: "", grownup: "", kit: "", number: "", height: "", orientation: design.orientation || "portrait", photoRef: "", grownupPhotoRef: "", later: false, uploading: 0 };
  // an ad or email can choose the variant: ?variant=<id>
  (function () {
    var id = Number(new URLSearchParams(location.search).get("variant"));
    for (var k in design.variants) if (design.variants[k].id === id) { var sf = k.split("/"); state.size = sf[0]; state.frame = sf[1]; }
  })();
  // which way round: ?orientation=landscape|portrait (an ad or email can choose), else the design's own default
  // (only while the choice is on: with HERO_ORIENTATION_CHOICE off each design is fixed at its default)
  (function () { if (!D.orientationChoice) return; var o = (new URLSearchParams(location.search).get("orientation") || "").toLowerCase(); if (o === "landscape" || o === "portrait") state.orientation = o; })();
  // Dad and me: ?who=dad|grandad (Dad by default); combines with ?variant=
  if (has("who")) {
    var w = (new URLSearchParams(location.search).get("who") || "").toLowerCase();
    state.who = D.who.some(function (x) { return x.code === w; }) ? w : "dad";
    var pre = D.who.filter(function (x) { return x.code === state.who; })[0];
    state.grownup = pre ? pre.prefill : "";
  }
  var seen = {};
  function once(name, props) { if (seen[name]) return; seen[name] = 1; track(name, props); }
  // only the real shop counts: theme previews and the myshopify address are build and review traffic
  var LIVE = /(^|\.)footballwallcharts\.com$/.test(location.hostname);
  function track(name, props) { if (!LIVE) return; try { if (window.posthog && posthog.capture) posthog.capture(name, Object.assign({ design: design.code }, props || {})); } catch (e) {} }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(c) { return "£" + (c / 100).toFixed(2); }
  function variant() { return design.variants[state.size + "/" + state.frame]; }
  function nameOr(fallback) { return state.child ? state.child.toUpperCase() : fallback; }

  // the theme's header sits over the top of the page: measure it and pad the page by that much
  (function () {
    var apply = function () {
      var h = document.querySelector("header-component, .header-section header, header.header");
      var px = h ? Math.round(h.getBoundingClientRect().height) : 0;
      if (px > 0) root.style.setProperty("--fwh-header-h", px + "px");
    };
    apply(); addEventListener("resize", apply); setTimeout(apply, 300);
  })();
  var fill = function (sel, v) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = v; }); };
  fill(".fwh-eta", D.eta); fill(".fwh-eta-short", D.etaShort); fill(".fwh-d-today", D.todayShort); fill(".fwh-d-proof", D.proofShort); fill(".fwh-d-eta", D.etaShort);

  // the theme's FAQ is shared by all three prints: on Dad and me and You as the pro, the "real player" question becomes this print's own
  var FAQ = {
    DAD: ["Do I need a photo of the grown-up too?", "It's optional, but it helps us get them right. Add it on this page, or send it after you order. Most of the picture shows their back, so a photo from behind works too."],
    PRO: ["Will it look like them?", "We make it from your photo, so a clear photo of their face, in good light, gives the best likeness. You see a free proof before anything is printed, and changes are free."]
  }[design.code];
  if (FAQ) document.querySelectorAll(".fp-faq-item").forEach(function (d) {
    var q = d.querySelector("summary"); if (!q || !/real player/i.test(q.textContent)) return;
    var t = Array.prototype.filter.call(q.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })[0];
    if (t) t.textContent = FAQ[0] + " ";
    var a = d.querySelector(".fp-faq-answer p") || d.querySelector(".fp-faq-answer"); if (a) a.textContent = FAQ[1];
  });

  /* ---------- gallery ---------- */
  var track_ = $("fwh-track"), thumbs = root.querySelectorAll(".fwh-thumb-btn");
  var current = 0;
  thumbs.forEach(function (b, i) { b.addEventListener("click", function () { track_.scrollTo({ left: i * track_.clientWidth, behavior: "smooth" }); track("fwh_gallery_thumb", { slide: i + 1 }); }); });
  track_.addEventListener("scroll", function () {
    var i = Math.round(track_.scrollLeft / Math.max(1, track_.clientWidth));
    if (i === current) return;
    current = i;
    thumbs.forEach(function (b, j) { b.classList.toggle("is-on", i === j); });
    var on = thumbs[i]; if (on && on.scrollIntoView) { var strip = on.parentNode; strip.scrollTo({ left: on.offsetLeft - strip.clientWidth / 2 + on.clientWidth / 2, behavior: "smooth" }); }
    if (i > 0) once("fwh_gallery_swipe");
    once("fwh_gallery_slide_" + (i + 1));
  }, { passive: true });

  // slide 9: the video loads only when it comes into view, plays muted and loops, and pauses when it leaves
  var video = track_.querySelector(".fwh-video");
  if (video && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio >= 0.5) {
          if (!video.getAttribute("src")) { video.src = video.getAttribute("data-src"); once("fwh_video_seen"); }
          var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (!video.paused) video.pause();
      });
    }, { root: track_, threshold: [0, 0.5] }).observe(video);
  }

  function artSet() { return (design.sets[state.who === "grandad" ? "grandad" : state.who ? "dad" : "main"] || design.sets.main || design.sets.dad) + (state.orientation === "landscape" ? "-landscape" : ""); }
  // sizes are written width × height: landscape swaps them ("21 × 30 cm" becomes "30 × 21 cm")
  var turn = function (t) { return state.orientation === "landscape" ? t.replace(/^([\d.]+) × ([\d.]+)/, "$2 × $1") : t; };
  function paintGallery() {
    var a = D.art[artSet()], slides = track_.querySelectorAll(".fwh-slide");
    // slide 1 on a phone is the tighter crop (2 Nov), so the print fills the slot
    var phone = window.matchMedia && matchMedia("(max-width: 989px)").matches;
    var first = a.first[state.frame]; if (phone) first = first.replace(/(-g01-[a-z]+)\.webp/, "$1-m.webp");
    var srcs = [first].concat(a.slides), fr = labelOf(state.frame).toLowerCase();
    slides.forEach(function (fig, i) {
      var want = srcs[i].split("?")[0].split("/").pop().replace(/\.webp$/, "");
      var alt = i === 0 ? a.alt + (state.frame === "NONE" ? ", the print on its own" : ", in a " + fr + " frame") + ", with their photo on a phone" : a.alt + ": " + D.slideNames[i];
      var img = fig.querySelector("img");
      if (img) {
        img.alt = alt;
        if (!(img.currentSrc && img.currentSrc.indexOf(want) >= 0)) { var so = i === 0 && img.parentNode && img.parentNode.querySelector("source"); if (so) so.remove(); img.removeAttribute("srcset"); img.src = srcs[i]; }
      } else if (fig.querySelector("video")) {
        var v = fig.querySelector("video");
        if (v.getAttribute("poster").indexOf(want) < 0) v.setAttribute("poster", srcs[i]);
        if (v.getAttribute("data-src") !== a.video) { v.setAttribute("data-src", a.video); if (v.getAttribute("src")) v.src = a.video; }
      }
      var t = thumbs[i] && thumbs[i].querySelector("img");
      if (t && t.getAttribute("src").indexOf(want) < 0) t.src = srcs[i];
    });
    root.querySelectorAll("#fwh-how img[data-step]").forEach(function (img) { var src = a.steps[+img.getAttribute("data-step")]; if (img.getAttribute("src") !== src) img.src = src; });
  }

  /* ---------- the price line ---------- */
  // the 3 for 2 switch (src/hero.ts HERO_OFFER_3FOR2): off hides every .fwh-o3 on the page and in its pop-ups
  if (D.offer3for2 === false) document.documentElement.classList.add("fwh-no-o3");
  if ($("fwh-offer-toggle")) $("fwh-offer-toggle").addEventListener("click", function () {
    var more = $("fwh-offer-more"), openNow = more.hidden;
    more.hidden = !openNow; this.setAttribute("aria-expanded", String(openNow));
    if (openNow) once("fwh_offer_opened");
  });

  /* ---------- step 1 ---------- */
  function paintStep1() {
    $("fwh-orients").hidden = !D.orientationChoice;
    if (D.orientationChoice) $("fwh-orients").innerHTML = D.orientations.map(function (o) {
      return '<button type="button" class="fwh-pill fwh-orient" role="radio" aria-checked="' + (o.code === state.orientation) + '" data-o="' + o.code + '"><i class="fwh-o-' + o.code + '" aria-hidden="true"></i>' + esc(o.label) + "</button>";
    }).join("");
    root.classList.toggle("is-landscape", state.orientation === "landscape");
    var sz = $("fwh-acc-sizes"); if (sz) sz.textContent = D.sizes.map(function (z) { return z.code + " " + turn(z.cm); }).join(", ") + (state.orientation === "landscape" ? ", landscape (wider than tall)" : ", portrait (taller than wide)") + ".";
    $("fwh-sizes").innerHTML = D.sizes.map(function (s) {
      var on = s.code === state.size;
      var pick = s.code === "A3" && state.frame !== "NONE" ? '<span class="fwh-pick">Our pick</span>' : "";
      return '<button type="button" class="fwh-pill" role="radio" aria-checked="' + on + '" data-s="' + s.code + '">' + pick + s.code + " · " + esc(turn(s.cm)) + "<small>" + money(design.variants[s.code + "/" + state.frame].price) + "</small></button>";
    }).join("");
    $("fwh-frames").innerHTML = D.frames.map(function (f) {
      return '<button type="button" class="fwh-frame" role="radio" aria-checked="' + (f.code === state.frame) + '" data-f="' + f.code + '"><i aria-hidden="true"></i>' + esc(f.label) + "</button>";
    }).join("");
    var v = variant();
    // no big price above the size picker (Philip, 2 Nov): the cards and the button carry the exact price
    paintGallery();
    paintButton();
    try { var u = new URL(location.href); u.searchParams.set("variant", v.id); if (state.who) u.searchParams.set("who", state.who); if (D.orientationChoice) u.searchParams.set("orientation", state.orientation); history.replaceState(history.state, "", u); } catch (e) {}
  }
  $("fwh-orients").addEventListener("click", function (e) { var b = e.target.closest("[data-o]"); if (!b || b.getAttribute("data-o") === state.orientation) return; state.orientation = b.getAttribute("data-o"); paintStep1(); once("fwh_step1", { via: "orientation" }); track("fwh_orientation", { orientation: state.orientation }); });
  $("fwh-sizes").addEventListener("click", function (e) { var b = e.target.closest("[data-s]"); if (!b) return; state.size = b.getAttribute("data-s"); paintStep1(); once("fwh_step1", { via: "size" }); });
  $("fwh-frames").addEventListener("click", function (e) { var b = e.target.closest("[data-f]"); if (!b) return; state.frame = b.getAttribute("data-f"); paintStep1(); once("fwh_step1", { via: "frame" }); });

  /* ---------- step 2 ---------- */
  function field(id, label, opts) {
    return '<div class="fwh-field"><label class="fwh-label" for="' + id + '">' + label + "</label>" +
      '<input class="fwh-input" id="' + id + '" type="' + (opts.type || "text") + '" maxlength="' + opts.max + '" autocomplete="off" autocapitalize="' + (opts.caps || "characters") + '" spellcheck="false"' + (opts.ph ? ' placeholder="' + esc(opts.ph) + '"' : "") + (opts.mode ? ' inputmode="' + opts.mode + '"' : "") + ">" +
      (opts.help ? '<p class="fwh-help" id="' + id + '-help">' + opts.help + "</p>" : "") +
      (opts.echo ? '<p class="fwh-echo" id="' + id + '-echo" aria-live="polite" hidden></p>' : "") + '<p class="fwh-err" id="' + id + '-err" hidden></p></div>';
  }
  var CAM = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  function photoCard(which) {
    var gp = which === "grownup";
    return '<div class="fwh-field fwh-photo" id="fwh-photo-' + which + '"><span class="fwh-label">' + (gp ? "The grown-up's photo <small>(optional)</small>" : 'Add <span class="fwh-nm">their</span> photo') + "</span>" +
      '<input type="file" accept="image/*" hidden>' +
      '<button type="button" class="fwh-choose fwh-zone">' + CAM + '<span class="fwh-zone-t">' + (gp ? "Add the grown-up's photo" : 'Add <span class="fwh-nm">their</span> photo') + '</span><span class="fwh-zone-s">Choose from your camera roll</span></button>' +
      '<div class="fwh-thumb" hidden><img alt=""><p></p><button type="button" class="fwh-link fwh-change">Change</button></div><p class="fwh-soft" hidden></p>' +
      (gp ? "" : '<ul class="fwh-chips"><li>Face clearly visible</li><li>Good light</li><li>The original photo</li></ul>' +
        '<button type="button" class="fwh-later" id="fwh-later">No photo to hand? Send it after you order</button>' +
        '<p class="fwh-later-on" id="fwh-later-on" hidden>You\'ll send the photo after you order, from your confirmation email. <button type="button" class="fwh-link" id="fwh-later-undo">Add it now instead</button></p>') +
      '<p class="fwh-err" hidden></p></div>';
  }
  var html = "";
  if (has("who")) html += '<div class="fwh-field"><span class="fwh-label" id="fwh-who-l">Who\'s going with them?</span><div class="fwh-who" id="fwh-who" role="radiogroup" aria-labelledby="fwh-who-l">' +
    D.who.map(function (x) { return '<button type="button" class="fwh-pill" role="radio" aria-checked="' + (x.code === state.who) + '" data-w="' + x.code + '">' + esc(x.label) + "</button>"; }).join("") + "</div></div>";
  html += field("fwh-child", "Child's name <small>(on their shirt)</small>", { max: 14, echo: true });
  if (has("number")) html += field("fwh-number", "Child's shirt number <small>(optional)</small>", { max: 2, mode: "numeric", caps: "off" });
  if (has("height")) html += '<div class="fwh-field"><label class="fwh-label" for="fwh-height">Child\'s approximate height <small>(optional)</small></label><select class="fwh-input fwh-select" id="fwh-height"><option value="">Choose</option>' +
    D.heights.map(function (a) { return '<option value="' + esc(a) + '">' + esc(a) + "</option>"; }).join("") + "</select></div>";
  if (has("grownup")) html += field("fwh-grownup", "Grown-up's name <small>(e.g. DAD, GRANDAD, NANA, or a first name)</small>", { max: 14, echo: true });
  // no placeholder (Philip, 30 Oct): an example would name a real player or mean nothing; the hero's number is worked out after the order
  if (has("hero")) html += field("fwh-hero", "Their hero", { max: 30, caps: "sentences", ph: "e.g. their favourite player" });
  // the kit is typed (Philip, 30 Oct): a team or the colours. Only a plain kit description made from it ever reaches the image model (fw-proof kit.ts)
  html += field("fwh-kit", "Their team's kit", { max: 60, caps: "sentences", ph: "Type their team, or describe the colours", help: "We match the colours and stripes. No badges or sponsors." });
  html += photoCard("child");
  if (has("grownupPhoto")) html += photoCard("grownup");
  $("fwh-fields").innerHTML = html;
  root.classList.add("is-built"); // the buy box shows once the fields above it are in, so it never paints high and drops

  function bindName(id, key) {
    var el = $(id); if (!el) return;
    el.addEventListener("input", function () {
      var v = el.value.replace(/\s{2,}/g, " ");
      if (!NAME_RE.test(v)) v = v.replace(/[^A-Za-zÀ-ÖØ-öø-ÿĀ-ž' \-]/g, "");
      if (v !== el.value) el.value = v;
      state[key] = v.trim();
      var ec = $(id + "-echo"); ec.hidden = !state[key]; ec.innerHTML = state[key] ? '<span>On the print</span><b class="fwh-shirt">' + esc(state[key].toUpperCase()) + "</b>" : "";
      el.removeAttribute("aria-invalid"); $(id + "-err").hidden = true;
      root.querySelectorAll(".fwh-nm").forEach(function (n) { n.textContent = state.child ? state.child.toUpperCase() + "'s" : "their"; });
      once("fwh_step2", { field: key });
    });
  }
  bindName("fwh-child", "child");
  if (has("who")) {
    $("fwh-grownup").value = state.grownup;
    var ge = $("fwh-grownup-echo"); ge.hidden = !state.grownup; ge.innerHTML = state.grownup ? '<span>On the print</span><b class="fwh-shirt">' + esc(state.grownup) + "</b>" : "";
    $("fwh-who").addEventListener("click", function (e) {
      var b = e.target.closest("[data-w]"); if (!b) return;
      var before = D.who.filter(function (x) { return x.code === state.who; })[0];
      state.who = b.getAttribute("data-w");
      this.querySelectorAll("[data-w]").forEach(function (x) { x.setAttribute("aria-checked", String(x === b)); });
      var now = D.who.filter(function (x) { return x.code === state.who; })[0], g = $("fwh-grownup");
      // only replace what we filled in ourselves: a typed NANA or first name stays
      if (!g.value.trim() || (before && g.value.trim().toUpperCase() === before.prefill)) {
        g.value = now.prefill; g.dispatchEvent(new Event("input"));
        if (!now.prefill) g.focus();
      }
      paintStep1(); once("fwh_step2", { field: "who" }); track("fwh_who", { who: state.who });
    });
  }
  bindName("fwh-grownup", "grownup");
  if ($("fwh-hero")) $("fwh-hero").addEventListener("input", function () { state.hero = this.value.trim(); this.removeAttribute("aria-invalid"); $("fwh-hero-err").hidden = true; once("fwh_step2", { field: "hero" }); });
  if ($("fwh-number")) $("fwh-number").addEventListener("input", function () { this.value = this.value.replace(/\D/g, "").slice(0, 2); state.number = this.value; });
  if ($("fwh-height")) $("fwh-height").addEventListener("change", function () { state.height = this.value; once("fwh_step2", { field: "height" }); });
  $("fwh-kit").addEventListener("input", function () { state.kit = this.value.replace(/\s{2,}/g, " ").trim(); this.removeAttribute("aria-invalid"); $("fwh-kit-err").hidden = true; once("fwh_step2", { field: "kit" }); });

  /* ---------- the photo ---------- */
  function bindPhoto(which) {
    var card = $("fwh-photo-" + which); if (!card) return;
    var input = card.querySelector("input[type=file]"), btn = card.querySelector(".fwh-choose"), err = card.querySelector(".fwh-err");
    var thumb = card.querySelector(".fwh-thumb"), soft = card.querySelector(".fwh-soft");
    btn.addEventListener("click", function () { input.click(); });
    card.querySelector(".fwh-change").addEventListener("click", function () { input.click(); });
    input.addEventListener("change", async function () {
      var f = input.files && input.files[0]; if (!f) return;
      err.hidden = true; state.uploading++; paintButton();
      thumb.hidden = false; btn.hidden = true; var img = thumb.querySelector("img"), txt = thumb.querySelector("p");
      try { img.src = URL.createObjectURL(f); } catch (e) {}
      txt.textContent = "Uploading…";
      track("fwh_photo_chosen", { which: which, kb: Math.round(f.size / 1024), type: f.type || "unknown" });
      C().photoAdvice(f).then(function (a) { soft.textContent = a; soft.hidden = !a; });
      try {
        var t0 = Date.now(), ref = await C().upload(f, function (p) { txt.textContent = "Uploading… " + Math.round(p * 100) + "%" + (Date.now() - t0 > 20000 ? " · big photos can take a minute" : ""); });
        if (which === "child") { state.photoRef = ref; setLater(false); } else state.grownupPhotoRef = ref;
        txt.textContent = "Photo added ✓";
        track("fwh_photo_uploaded", { which: which });
      } catch (e) {
        txt.textContent = ""; thumb.hidden = true; btn.hidden = false;
        err.textContent = which === "child" ? "That photo didn't upload. Please try again, or send it after you order." : "That photo didn't upload. Please try again.";
        err.hidden = false; track("fwh_photo_failed", { which: which, error: String(e && e.message).slice(0, 60) });
      } finally { state.uploading--; paintButton(); input.value = ""; }
    });
  }
  bindPhoto("child"); bindPhoto("grownup");
  function setLater(on) {
    state.later = on;
    if ($("fwh-later")) $("fwh-later").hidden = on;
    if ($("fwh-later-on")) $("fwh-later-on").hidden = !on;
    paintButton();
  }
  $("fwh-later").addEventListener("click", function () { setLater(true); track("fwh_later_on"); });
  $("fwh-later-undo").addEventListener("click", function () { setLater(false); $("fwh-photo-child").querySelector(".fwh-choose").click(); });

  /* ---------- the one button ---------- */
  var buttons = [$("fwh-atc")];
  function paintButton() {
    var t = state.uploading ? "Uploading your photo…" : state.later && !state.photoRef ? "Add to basket · send photo later" : "Add to basket · " + money(variant().price);
    buttons.forEach(function (b) { if (!b.dataset.busy) b.textContent = t; });
  }
  function fail(id, msg) {
    var el = $(id), e = $(id + "-err");
    if (el) el.setAttribute("aria-invalid", "true");
    if (e) { e.textContent = msg; e.hidden = false; }
    return el || e;
  }
  function validate() {
    var first = null, f;
    if (!state.child) first = first || fail("fwh-child", "Please add their name.");
    if (has("grownup") && !state.grownup) { f = fail("fwh-grownup", "Please add the grown-up's name."); first = first || f; }
    if (has("hero") && !state.hero) { f = fail("fwh-hero", "Please tell us who their hero is."); first = first || f; }
    if (!state.kit) { f = fail("fwh-kit", "Please tell us their team, or the kit colours."); first = first || f; }
    if (first) { first.scrollIntoView({ behavior: "smooth", block: "center" }); if (first.focus) setTimeout(function () { first.focus({ preventScroll: true }); }, 350); track("fwh_add_blocked", { missing: [!state.child && "child", has("grownup") && !state.grownup && "grownup", has("hero") && !state.hero && "hero", !state.kit && "kit"].filter(Boolean).join(",") }); }
    return !first;
  }
  function openSheet(id) { var el = $(id); if (!el.open) { try { el.showModal(); } catch (e) { el.setAttribute("open", ""); } } return el; }
  root.querySelectorAll("dialog.fwh-sheet").forEach(function (d) { d.addEventListener("click", function (e) { if (e.target === d || e.target.closest("[data-close]")) d.close(); }); });
  root.querySelectorAll("[data-open]").forEach(function (b) { b.addEventListener("click", function () {
    if (b.getAttribute("data-open") === "fwh-photoguide") { fillPhotoGuide(); track("fwh_photo_guide_opened", { from: b.className.indexOf("photoguide") >= 0 ? "pill" : "link" }); }
    if (b.getAttribute("data-open") === "fwh-sizeguide") { fillSizeGuide(); track("fwh_size_guide_opened", { size: state.size, frame: state.frame }); }
    openSheet(b.getAttribute("data-open")); track("fwh_sheet_" + b.getAttribute("data-open").replace("fwh-", "")); }); });

  async function onAdd(trigger) {
    $("fwh-error").hidden = true;
    if (state.uploading) return;
    if (!validate()) return;
    if (!state.photoRef && !state.later) { root.querySelectorAll(".fwh-nm").forEach(function (n) { n.textContent = nameOr("their") + (state.child ? "'s" : ""); }); openSheet("fwh-needphoto"); track("fwh_need_photo"); return; }
    if (!state.photoRef && state.later) { confirmLater(); return; }
    await doAdd(trigger);
  }
  function confirmLater() {
    var v = variant(), rows = [["Print", design.title], ["Size", state.size + ", " + labelOf(state.frame)], ["Name", state.child.toUpperCase()]];
    if (has("grownup")) rows.push(["Grown-up", state.grownup.toUpperCase()]);
    rows.push(["Price", money(v.price)]);
    $("fwh-cf-summary").innerHTML = rows.map(function (r) { return "<dt>" + esc(r[0]) + "</dt><dd>" + esc(r[1]) + "</dd>"; }).join("");
    openSheet("fwh-confirm"); track("fwh_confirm_later_shown");
  }
  function labelOf(f) { for (var i = 0; i < D.frames.length; i++) if (D.frames[i].code === f) return D.frames[i].label; return f; }
  $("fwh-cf-go").addEventListener("click", async function () { $("fwh-confirm").close(); await doAdd("confirm-later"); });
  $("fwh-cf-photo").addEventListener("click", function () { $("fwh-confirm").close(); setLater(false); $("fwh-photo-child").querySelector(".fwh-choose").click(); });
  $("fwh-np-choose").addEventListener("click", function () { $("fwh-needphoto").close(); $("fwh-photo-child").querySelector(".fwh-choose").click(); });
  $("fwh-np-later").addEventListener("click", function () { $("fwh-needphoto").close(); setLater(true); track("fwh_later_on", { via: "need-photo-sheet" }); confirmLater(); });

  async function doAdd(trigger) {
    buttons.forEach(function (b) { b.dataset.busy = "1"; b.disabled = true; b.textContent = "Adding…"; });
    try {
      var s = pageState();
      await C().addLine(design.code, s, /[?&]src=set-tile/.test(location.search) ? "set-tile" : "pdp");
      track("fwh_add", { trigger: trigger, size: state.size, frame: state.frame, photo: state.photoRef ? "now" : "later" });
      C().openDrawer();
    } catch (e) {
      $("fwh-error").textContent = "Sorry, that didn't add to your basket. Please tap the button again."; $("fwh-error").hidden = false;
    } finally { buttons.forEach(function (b) { delete b.dataset.busy; b.disabled = false; }); paintButton(); }
  }
  $("fwh-atc").addEventListener("click", function () { onAdd("main"); });

  // "Personalise it": shows once the buy box has scrolled off the top (phones only, by CSS), hidden while it is on screen;
  // takes them back to the start of step 2 and the first box still empty
  try {
    var back = $("fwh-back");
    new IntersectionObserver(function (es) { es.forEach(function (e) { back.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }); }, { threshold: 0 }).observe($("fwh-buy"));
    back.addEventListener("click", function () {
      $("fwh-step2").scrollIntoView({ behavior: "smooth", block: "start" });
      var empty = [].slice.call(root.querySelectorAll("#fwh-fields input.fwh-input")).filter(function (i) { return !i.value; })[0];
      if (empty) setTimeout(function () { empty.focus({ preventScroll: true }); }, 600);
      track("fwh_back_to_form", { filled: !!state.child });
    });
  } catch (e) {}

  /* ---------- arriving from the basket sheet's tiles (fwh-cart.js) ---------- */
  // arriving from another design's tile: its name, kit, number and photo come with it
  function prefill() {
    var q = new URLSearchParams(location.search), set = function (id, v) { var el = $(id); if (el && v) { el.value = v; el.dispatchEvent(new Event("input")); } };
    set("fwh-child", (q.get("child") || "").slice(0, 14));
    set("fwh-number", (q.get("number") || "").replace(/\D/g, "").slice(0, 2));
    set("fwh-kit", (q.get("kit") || "").slice(0, 60));
    var ref = q.get("photo_ref");
    if (ref && /^[a-f0-9]{16,40}$/.test(ref)) {
      state.photoRef = ref;
      var card = $("fwh-photo-child"), th = card.querySelector(".fwh-thumb");
      th.hidden = false; th.querySelector("img").hidden = true; th.querySelector("p").textContent = "Photo added ✓ (the one from your other print)";
      card.querySelector(".fwh-choose").hidden = true;
    }
    if (q.get("src") === "set-tile") track("fwh_arrived_from_tile", { filled: !!q.get("child") });
  }


  /* ---------- the two guides, and the open photo guide on the page ---------- */
  var GOOD = ["Face clearly visible", "Good daylight", "Looking at the camera"], HARD = ["Too dark", "Too far away", "Blurry or a WhatsApp forward"];
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#1F7A3A"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#A42325"/><path d="M8 8l8 8M16 8l-8 8" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>';
  function tile(src, ok, label) { return '<figure class="fwh-pg-tile"><img src="' + esc(src) + '" alt="' + esc(label) + '" width="400" height="400" loading="lazy"><figcaption>' + (ok ? TICK : CROSS) + "<span>" + esc(label) + "</span></figcaption></figure>"; }
  var G = D.guide, pgTiles = G.pgOk.map(function (src, i) { return tile(src, true, GOOD[i]); }).join("") + G.pgHard.map(function (src, i) { return tile(src, false, HARD[i]); }).join("");
  function fillPhotoGuide() {
    $("fwh-pg-grid").innerHTML = pgTiles;
    $("fwh-pg-grown").hidden = !has("grownupPhoto");
    if (has("grownupPhoto")) $("fwh-pg-grown-grid").innerHTML = tile(G.pgGrown[0], true, "Works well") + tile(G.pgGrown[1], true, "From behind is fine");
  }
  function fillSizeGuide() {
    var img = $("fwh-sg-img"), src43 = $("fwh-sg-src43");
    var l = state.orientation === "landscape", s45 = l ? G.sizesL45 : G.sizes45, s43 = l ? G.sizesL43 : G.sizes43;
    if (img.getAttribute("src") !== s45) img.src = s45;
    if (src43.getAttribute("srcset") !== s43) src43.setAttribute("srcset", s43);
    $("fwh-sg-rows").innerHTML = D.sizes.map(function (z) {
      var pick = z.code === "A3" ? ' <span class="fwh-sg-pick">Our pick</span>' : "";
      return "<tr" + (z.code === state.size ? ' class="is-on"' : "") + "><td><b>" + z.code + "</b>" + pick + "</td><td>" + esc(turn(z.guide.cm)) + " cm<br><small>" + esc(turn(z.guide.inches)) + " in</small></td><td>" + money(design.variants[z.code + "/NONE"].price) + "</td><td>" + money(design.variants[z.code + "/BLACK"].price) + "</td><td>" + esc(z.guide.goodFor) + "</td></tr>";
    }).join("");
  }

  function pageState() {
    return { code: design.code, who: state.who, size: state.size, frame: state.frame, child: state.child, hero: state.hero, grownup: state.grownup.toUpperCase(), kit: state.kit, number: state.number, height: state.height, orientation: state.orientation, photoRef: state.photoRef, grownupPhotoRef: state.grownupPhotoRef };
  }
  window.FWHPage = { state: pageState };

  /* ---------- funnel: how far down people got before leaving ---------- */
  var maxY = 0;
  addEventListener("scroll", function () { maxY = Math.max(maxY, scrollY + innerHeight); }, { passive: true });
  addEventListener("pagehide", function () { track("fwh_exit", { max_px: Math.round(Math.max(maxY, innerHeight)), first_screen_only: maxY <= innerHeight + 40, step2: !!seen.fwh_step2 }); });
  track("fwh_view", { who: state.who || undefined, size: state.size, frame: state.frame, variant_from_url: /[?&]variant=/.test(location.search) });

  prefill(); paintStep1();
})();
